<section class="footer d-none d-lg-block">
  <div class="container">
    <div class="bodyWrapper d-flex align-items-center justify-content-between">
      <div class="leftPanel">
        <a href="/assets/documents/whitepaper.pdf" target="_blank">{{"footer.read_whitepaper" | translate }}</a>
      </div>
      <div class="middlePanel drop-shadow">
       <img src="assets/images/svg-icons/token.svg" class="img-fluid token-icon" alt="Pepe Token">
        <div>{{"footer.earn_bouns" | translate }}</div>
        <div class="percent">20%</div>
      </div>
      <div class="rightPanel">
        <a href="/assets/documents/privacy_policy.pdf" target="_blank">{{"footer.privacy" | translate }}</a>
        <a href="/assets/documents/cookies.pdf" target="_blank">{{"footer.cookies" | translate }}</a>

        <a href="/assets/documents/terms_of_service.pdf" target="_blank">{{"footer.terms" | translate }}</a>

      </div>
    </div>
  </div>
</section>

<section class="footer d-block d-lg-none">
  <div class="container">
    <div class="d-flex align-items-center justify-content-between">
      <div class="leftPanel">
        <a href="/assets/documents/whitepaper.pdf" target="_blank">{{"footer.read_whitepaper" | translate }}</a>
        <a href="/assets/documents/privacy_policy.pdf" target="_blank">{{"footer.privacy" | translate }}</a>
        <a href="/assets/documents/cookies.pdf" target="_blank">{{"footer.cookies" | translate }}</a>

        <a href="/assets/documents/terms_of_service.pdf" target="_blank">{{"footer.terms" | translate }}</a>

      </div>
      <div class="middlePanel drop-shadow">
        <img src="assets/images/svg-icons/pepe-token.svg" class="img-fluid token-icon" alt="Pepe Token">
        <div>{{"footer.earn_bouns" | translate }}</div>
        <div class="percent">20%</div>
      </div>
      <div class="rightPanel">
        <img src="assets/images/png/faq_laptop.png" alt="Laptop" class="d-block mwx-118">
      </div>
    </div>

    <div class="text-center fs-6 mb-1 d-block d-lg-none">{{"footer.disclaimer" | translate }}</div>
    <div class="text-center fs-6 d-block d-lg-none">{{"footer.disclaimer_des" | translate }}</div>
  </div>
</section>
